/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Mention_Everyone_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to use @everyone (everyone in the server) or @here (only online members in that channel). They can also @mention all roles, even if the role’s..." |
*
* @param {Leveling_Perm_Mention_Everyone_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_mention_everyone_hint = /** @type {((inputs?: Leveling_Perm_Mention_Everyone_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Mention_Everyone_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам упоминать @everyone (всех на сервере) и @here (только участников в сети в этом канале). Кроме того, они могут упоминать любые роли, даже если у роли выключено право «Разрешить всем @упоминать эту роль».")
	return /** @type {LocalizedString} */ ("Allows members to use @everyone (everyone in the server) or @here (only online members in that channel). They can also @mention all roles, even if the role’s ‘Allow anyone to mention this role’ permission is disabled.")
});